// As we're using immer
import { createSlice } from '@reduxjs/toolkit';
export function getFreeModeState(localStorageKey, defaultValue = false) {
    const string = window.localStorage.getItem(localStorageKey);
    return string == null ? defaultValue : string === 'true';
}
export const DistractionFreeMode = '__distractionFree';
export const DocumentTabsFreeMode = '__documentsTabsFree';
const INITIAL_STATE = {
    distractionFreeMode: false,
    documentTabsFreeMode: true
};
const layoutSlice = createSlice({
    name: 'layout',
    initialState: INITIAL_STATE,
    reducers: (create)=>({
            toggleDistractionFreeMode: create.reducer((state, { payload })=>{
                return {
                    ...state,
                    distractionFreeMode: payload
                };
            }),
            toggleDocumentTabsFreeMode: create.reducer((state, { payload })=>{
                return {
                    ...state,
                    documentTabsFreeMode: payload
                };
            })
        })
});
export const selectDistractionFreeMode = ({ layout })=>layout.distractionFreeMode;
export const selectDocumentTabsFreeMode = ({ layout })=>layout.documentTabsFreeMode;
export const { toggleDistractionFreeMode, toggleDocumentTabsFreeMode } = layoutSlice.actions;
export const layoutReducer = layoutSlice.reducer;
